import { createSelector } from '@reduxjs/toolkit';
import { CONSTANTS_SETTINGS } from 'config/settingsContainer';

//📌 Selector for get all workspaces
export const selectWorkspaces = createSelector(
	[(state) => state.Organisations.data],
	(workspacesData) => workspacesData || []
);

// select workspace by workspace ID
export const selectWorkspaceByID = (state, workspaceID) => {
	const workspaces = selectWorkspaces(state);
	return workspaces.find((workspace) => workspace.orgID === workspaceID);
};

//📌 Selector to get room settings configuration
export const selectSettingsRoomConfiguration = createSelector(
	[(state) => state.Settings.orgSettings, (state) => state.Auth.selectedProfile?.orgID],
	(settings, orgID) => {
		const orgSetting = (settings[orgID] || []).find(
			(setting) => setting.defaultSettingID === CONSTANTS_SETTINGS.ROOMS_CONFIGURATION
		);

		if (!orgSetting) return {};

		try {
			const parsed = JSON.parse(orgSetting.value);
			return parsed || {};
		} catch (e) {
			console.error('Invalid JSON in ROOMS_CONFIGURATION setting', e);
			return {};
		}
	}
);
